/* eslint-disable */
"use strict";
import configurazioni from "@/services/configurazioniService.js";
import documenti from "@/services/documentiService.js";
import clienti from "@/services/clientiService.js";

var config, service, reporting;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  reporting = config.VUE_APP_MOL_S_REPORTING
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${reporting}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "REPORTING",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

const stampaDocumento = async function(
  router,
  item,
  linkEsterno,
  newWindow,
  senzaPrezzi,
  tipo = "pdfm"
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const documento = await documenti.getDocumento(item._id);
  if (documento) {
    const nomeReport =
      documento.tipoDocumento.nomeReport ||
      documento.tipoDocumento.tipoDocumento;
    // -------------------
    const elenco = await configurazioni.getConfigurazione("report", "report");
    const report = elenco.find((x) => x.nomeReport === nomeReport);
    if (!report) {
      return { error: `Report non trovato: ${nomeReport}` };
    }
    let impostazioni = null;
    if (report.impostazioni) {
      if (typeof report.impostazioni === "string") {
        const conf = report.impostazioni.split(".");
        if (conf && conf.length === 2) {
          impostazioni = await configurazioni.getConfigurazione(
            conf[0],
            conf[1]
          );
        } else {
          impostazioni = report.impostazioni; // TODO: Verificare.
        }
      } else if (Array.isArray(report.impostazioni)) {
        impostazioni = {};
        for (let impo of report.impostazioni) {
          const conf = impo.split(".");
          if (conf && conf.length === 2) {
            impostazioni[conf[1]] = await configurazioni.getConfigurazione(
              conf[0],
              conf[1]
            );
          }
        }
      } else {
        impostazioni = report.impostazioni; // TODO: Verificare
      }
    }
    let codice =
      _.get(documento, "anagrafica.cliente.codice", "") ||
      _.get(documento, "anagrafica.fornitore.codice", "");
    const anagrafica = await clienti.getCliente(codice);
    let parametri = {
      caricaLoghi: report.caricaLoghi || false,
      autoPrint: report.autoPrint || false,
      reportHeader: report.reportHeader || null,
      pageHeader: report.pageHeader || null,
      pageFooter: report.pageFooter || null,
      reportFooter: report.reportFooter || null,
      intestazione: report.intestazione || null,
      filtri: null,
      impostazioni: impostazioni,
      anagrafica: anagrafica.recapiti,
      senzaPrezzi: senzaPrezzi || null,
      mostraSpedizione: report.mostraSpedizione || false,
    };
    parametri.idDocumento = item._id;
    // -------------------
    const str = JSON.stringify(parametri);
    const buff = Buffer.from(str, "utf-8");
    const pathReportPrefix = config.VUE_APP_MOL_API_GATEWAY || "";
    debugger
    // const tipo = 'pdfm'
    // TODO: Fare Mixin + da impostazioni decidere se usare viewer interno o aprire su browser (stessa pagina o pagina nuova)
    const token = JSON.parse(localStorage.getItem("token_bk"));
    const source = `${pathReportPrefix}/${reporting}/${tipo ||
      "pdfm"}/${nomeReport}?par=${buff.toString("base64")}&token=${token}`;
    if (source) {
      if (tipo === "base64") {
        const file = await base64Report(source);
        return file;
      } else {
        router
          .push({
            name: linkEsterno ? "Pdf-e" : "Pdf",
            params: { source: source, newWindow: newWindow },
          })
          .catch(() => {});
      }
    }
  }
};

async function base64Report(source) {
  // const source = `${pathReportPrefix}/${reporting}/${tipo || 'pdfm'}/${nomeReport}?par=${buff.toString('base64')}`
  try {
    const response = await fetch(source);
    return await response.json();
  } catch (err) {
    console.log("errore", err);
    return "";
  }
}

const submitBatchReport = async (source, nomeFile) => {
  try {
    const data = {
      nomeFile,
    };
    const response = await fetch(source, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    return await response.json();
  } catch (err) {
    return { status: "error", message: err.message };
  }
};

async function statoElaborazione(nomeReport) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${reporting}/batch/status?nr=${nomeReport}`
    );
    return await response.json();
  } catch (err) {
    console.log("errore", err);
    return "";
  }
}

export default {
  getRunMode,
  stampaDocumento,
  submitBatchReport,
  statoElaborazione,
};
